import {ProgressBar, Spinner} from '@primer/react'
import {clsx} from 'clsx'

import type {UploadPlaceholderWidgetProps} from '../codemirror/widgets/upload-placeholder'
import styles from './UploadPlaceholder.module.css'

export function UploadPlaceholder(props: UploadPlaceholderWidgetProps) {
  const description = `Uploading ${props.fileName}...`

  if (props.mediaKind && props.previewUrl && !props.active) {
    return (
      <div
        className={clsx(styles.mediaPreview, props.mediaKind === 'image' && styles.inline)}
        style={{
          '--UploadPlaceholder-progress': props.progressPercent !== undefined ? `${props.progressPercent / 100}` : 0,
        }}
        role="status"
      >
        {props.mediaKind === 'image' ? (
          <img
            src={props.previewUrl}
            alt={description}
            height={props.dimensions?.height}
            width={props.dimensions?.width}
          />
        ) : (
          <video
            src={props.previewUrl}
            controls={false}
            autoPlay={false}
            muted
            aria-label={description}
            className={styles.video}
          />
        )}

        <div className={styles.overlay}>
          <ProgressBar progress={props.progressPercent} barSize="large" animated className={styles.progress} />
        </div>
      </div>
    )
  }

  return (
    <span role="status">
      <span className={styles.spinner}>
        <Spinner size="small" style={{verticalAlign: 'text-top'}} />
      </span>{' '}
      {description}
    </span>
  )
}

try{ UploadPlaceholder.displayName ||= 'UploadPlaceholder' } catch {}